<template>
  <div>
    <div v-if="loading">
      <div class="text-center">
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
      </div>
    </div>
    <div v-else>
      <div v-if="access != null && access.length === 0">
        <b-row class="align-center">
          <b-col><i>Aucune liste d'accès</i></b-col>
        </b-row>
        <!--b-row class="align-center">
          <b-col><b-button v-b-modal.modal-import-access-list variant="primary">Importer</b-button></b-col>
          <b-modal id="modal-import-access-list" title="Importer une liste de access" scrollable hide-footer>
            <form-import-list v-on:sendForm="receiveForm" :id="this.id"></form-import-list>
          </b-modal>
        </b-row-->
      </div>
      <div v-else>
        <b-button
          v-b-toggle="'list-invisible-access'"
          class="m-1"
          variant="info">
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_access')}}
          </b-button>
        <b-collapse id="list-invisible-access">
          <!--b-row class="align-center mb-4">
          <b-col><b-button v-b-modal.modal-import-access-list variant="primary">Importer</b-button></b-col>
          <b-modal id="modal-import-access-list" title="Importer une liste de access" scrollable hide-footer>
            <form-import-list v-on:sendForm="receiveForm" :id="this.id"></form-import-list>
          </b-modal>
        </b-row-->
          <b-row>
            <b-col>
              <b-form-group
                label="Filtrer"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                label-for="filterInput">
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Taper pour rechercher un accès"/>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''">Effacer</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :fields="fields"
            :items="access"
            :filter="filter"
            :filter-included-fields="filterOn"
            small
            responsive="sm">
            <template #cell(login)="row">
              <b-col>{{ row.item.acc_login }}</b-col>
            </template>
            <template #cell(status)="row">
              <b-col>
                <b-badge
                  v-if="row.item.acc_status"
                  variant="success">Actif</b-badge>
                <b-badge
                  v-else
                  variant="warning">Créé</b-badge>
              </b-col>
            </template>
            <template #cell(active)="row">
              <b-col>
                <b-badge
                  v-if="row.item.ace_is_enable"
                  variant="success">Utilisé</b-badge>
                <b-badge
                  v-else
                  variant="danger">Supprimé</b-badge>
              </b-col>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ListAccess',
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      title: 'List Staff',
      fields: [
        {
          login: {
            label: 'Identifiant',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          status: {
            label: 'Statut',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          active: {
            label: 'Utilisation',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      filter: null,
      filterOn: [],
      loading: true,
    };
  },
  computed: {
    access() {
      return this.$store.getters['access/accessByEstaId'](this.id);
    },
  },
  mounted() {
    this.$store.dispatch('access/getAccessByEstaId', this.id).then(() => { this.loading = false; });
  },
  methods: {
    setLoaded() {
      this.loading = false;
    },
  },
};
</script>
